import { Soup, Utensils, Coffee, Leaf, Candy, Clock, Truck, CheckCircle2, Ban, Banknote, CreditCard, FileText, AlertCircle, PackageX } from "lucide-react";

// Day names in Slovak language.
export const DAY_NAMES = [
  "Pondelok",
  "Utorok",
  "Streda",
  "Štvrtok",
  "Piatok",
  "Sobota",
  "Nedeľa",
];

// Short day abbreviations in Slovak language (same order as DAY_NAMES).
export const DAY_SHORT_NAMES = [
  "Po",
  "Ut",
  "St",
  "Št",
  "Pi",
  "So",
  "Ne",
];

// Shared order-status priority map.
// Lower number = higher priority (ACCEPTED appears first in sorted lists).
export const ORDER_STATUS_PRIORITY = {
  ACCEPTED:  1,
  DELIVERY:  2,
  DELIVERED: 3,
  CANCELLED: 4,
};

// Metadata pre typy položiek menu.
// label        – plurálny tvar (napr. pre nadpisy skupín v OrderModal)
// labelSingular – singulárny tvar (napr. pre záložky / tab buttony)
export const ITEM_TYPE_META = {
  SOUP:      { label: "Polievky",     labelSingular: "Polievka",     Icon: Soup,         order: 0 },
  MENU:      { label: "Hlavné jedlá", labelSingular: "Hlavné jedlo", Icon: Utensils,     order: 1 },
  DRINK:     { label: "Nápoje",       labelSingular: "Nápoj",        Icon: Coffee,       order: 2 },
  SIDE_DISH: { label: "Prílohy",      labelSingular: "Príloha",      Icon: Leaf,         order: 3 },
  DESSERT:   { label: "Dezerty",      labelSingular: "Dezert",       Icon: Candy,        order: 4 },
};

// Metadata pre stavy objednávok. Farby sú CSS premenné zo styles/theme.scss
// (svetlý aj tmavý režim): `color` pre text a výplň, `rgb` pre priehľadné
// odtiene — rgba(var(--status-rgb), 0.12). Nie color-mix(): ten html2canvas
// pri snímke obrazovky nevie prečítať.
export const ORDER_STATUS_META = {
  ACCEPTED:  { label: "Prijatá",  color: "var(--c-stav-prijata)",  rgb: "var(--c-stav-prijata-rgb)",  Icon: Clock        },
  DELIVERY:  { label: "Na trase", color: "var(--c-stav-na-trase)", rgb: "var(--c-stav-na-trase-rgb)", Icon: Truck        },
  DELIVERED: { label: "Doručená", color: "var(--c-success)",       rgb: "var(--c-success-rgb)",       Icon: CheckCircle2 },
  CANCELLED: { label: "Zrušená",  color: "var(--c-error)",         rgb: "var(--c-error-rgb)",         Icon: Ban          },
};

// Preklad typov platieb na čitateľné texty.
export const PAYMENT_TYPE_LABELS = {
  CASH:          "Hotovosť",
  CARD:          "Platba kartou",
  INVOICE:       "Faktúra",
  DEBT:          "Dlh",
  NOT_DELIVERED: "Nedoručené",
};

// Metadata pre typy platieb (ikona + label).
export const PAYMENT_TYPE_META = {
  CASH:          { label: "Hotovosť",      Icon: Banknote   },
  CARD:          { label: "Platba kartou", Icon: CreditCard },
  INVOICE:       { label: "Faktúra",       Icon: FileText   },
  DEBT:          { label: "Dlh",           Icon: AlertCircle },
  NOT_DELIVERED: { label: "Nedoručené",    Icon: PackageX   },
};

// Derived labels for daily menu display (from ITEM_TYPE_META).
export const ITEM_TYPE_LABELS = Object.fromEntries(
  Object.entries(ITEM_TYPE_META).map(([key, { label }]) => [key, label])
);

// Derived order array for sorting by type (from ITEM_TYPE_META).
export const ITEM_TYPE_ORDER = Object.entries(ITEM_TYPE_META)
  .sort(([, a], [, b]) => a.order - b.order)
  .map(([key]) => key);

// Allergens list (EU regulation 1169/2011).
export const ALLERGENS = [
  { id: 1,  label: "Obilniny obsahujúce lepok (pšenica, raž, jačmeň, ovos...)" },
  { id: 2,  label: "Kôrovce a výrobky z nich" },
  { id: 3,  label: "Vajcia a výrobky z nich" },
  { id: 4,  label: "Ryby a výrobky z nich" },
  { id: 5,  label: "Arašidy a výrobky z nich" },
  { id: 6,  label: "Sójové zrná a výrobky z nich" },
  { id: 7,  label: "Mlieko a výrobky z neho" },
  { id: 8,  label: "Orechy (mandle, lieskovce, vlašské, kešu, pekanové...)" },
  { id: 9,  label: "Zeler a výrobky z neho" },
  { id: 10, label: "Horčica a výrobky z nej" },
  { id: 11, label: "Sezamové semená a výrobky z nich" },
  { id: 12, label: "Oxid siričitý a siričitany (>10 mg/kg alebo mg/l)" },
  { id: 13, label: "Vlčí bôb a výrobky z neho" },
  { id: 14, label: "Mäkkýše a výrobky z nich" },
];
